import MCheckbox from "./MCheckbox";

export default MCheckbox;
